import React from "react";
import TiptapEditor from "./TiptapEditor";
import { RichTextValue } from "../RichTextField";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/shadcn/dialog";
import { type AdvancedChipOption } from "./chipOptionsConfig";

interface DialogEditorProps {
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
  content: RichTextValue;
  onSave: (content: RichTextValue) => void;
  chipOptions?: AdvancedChipOption[];
  unselectAllNodes?: () => any;
  label?: string;
  isSimpleText?: boolean;
}

const DialogEditor: React.FC<DialogEditorProps> = ({
  isOpen,
  onOpenChange,
  content,
  onSave,
  chipOptions,
  unselectAllNodes,
  label,
  isSimpleText,
}) => {
  const [editedContent, setEditedContent] =
    React.useState<RichTextValue>(content);

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onSave(editedContent);
    }
    onOpenChange(open);
  };

  return (
    <Dialog onOpenChange={handleOpenChange} open={isOpen} modal>
      <DialogContent
        className="bg-background flex flex-col h-[80%] w-[80%] max-w-[80%]!"
        stopPropagation
        onEscapeKeyDown={(e) => {
          e.stopPropagation();
        }}
      >
        <DialogHeader className="flex-shrink-0">
          <DialogTitle>{label || "Prompt"}</DialogTitle>
          {label === "Prompt" && (
            <DialogDescription>
              Edit the prompt to your needs. You can also use AI to build your
              prompt.
            </DialogDescription>
          )}
        </DialogHeader>
        <div className="flex flex-1 overflow-visible min-h-0 px-3 mb-2">
          <TiptapEditor
            onChange={setEditedContent}
            value={editedContent}
            chipOptions={chipOptions}
            fullSize={true}
            unselectAllNodes={unselectAllNodes}
            isSimpleText={isSimpleText}
            isControlled
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DialogEditor;
